import { Spinner } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import { Helmet } from 'react-helmet-async'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'

import StoreService from '@/store/StoreService'

import { ManageTriviaListsUser } from './manage-trivia-lists-user'

export const TriviaRoute = observer(() => {
  const { path } = useRouteMatch()
  const { currentGame, isLoadingGame } = StoreService.getStore()

  if (isLoadingGame) {
    return <Spinner label='Loading...' />
  }

  if (currentGame) {
    return <Redirect to='/game' />
  } else {
    return (
      <>
        <Helmet>
          <title>Manage Trivia Lists | Rockstar Bingo</title>
        </Helmet>

        <Route path={path} exact>
          <ManageTriviaListsUser />
        </Route>
      </>
    )
  }
})
